import { getContractsDir, sendAsyncErr, sendJsonRes } from '@taqueria/node-sdk';
import glob from 'fast-glob';
import { readFile } from 'fs/promises';
import { join } from 'path';
import { CompileAllOpts as Opts, CompileOpts, getInputFilename } from './common';
import { compileContract, TableRow } from './compile';

const contractHasCompTarget = (parsedArgs: Opts, contactFilename: string): Promise<boolean> =>
	readFile(getInputFilename(parsedArgs, contactFilename), 'utf8')
		.then(data => /add_(expression_)?compilation_target\s*\(\s*['"][^'"]+['"]/.test(data));

const compileAll = async (parsedArgs: Opts): Promise<void> => {
	let p: Promise<TableRow>[] = [];

	const contractFilenames = await glob(
		['**/*.py'],
		{ cwd: join(parsedArgs.config.projectDir, getContractsDir(parsedArgs)), absolute: false },
	);

	for (const filename of contractFilenames) {
		if (await contractHasCompTarget(parsedArgs, filename)) {
			p.push(compileContract(parsedArgs as CompileOpts, filename));
		}
	}

	return Promise.all(p).then(sendJsonRes).catch(err => sendAsyncErr(err, false));
};

export default compileAll;
